import { signal } from "@preact/signals-react";

export const sessionTimeRemaining = signal<number | undefined>(undefined);
